import { wrapper } from "../../redux";
import { fetchSections } from "../../redux/action-creaters/sections";
import Sections from "../../components/pages/sections";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import Redis from "/lib/redis";
import pagesWrapper from "../../utils/pagesWrapper";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { getBaltexSections } from "../../redux/action-creaters/baltex";
import { checkIsBaltex } from "../../utils";

export default function SectionsPage({ scripts, host }) {
  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <Sections section={null}></Sections>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps(function (store) {
  return async ({ query, req }) => {
    await store.dispatch(await fetchSections(Boolean(query.reset)));
    store.dispatch(addBreadcrumb({ link: "/catalog/", name: "Каталог" }));

    const isBaltex = checkIsBaltex(req.headers.host);

    if (isBaltex) {
      await store.dispatch(getBaltexSections(Boolean(query.reset)));
    }

    return pagesWrapper(
      {},
      store,
      Redis,
      {
        query,
        req,
      },
      "/catalog/",
    );
  };
});
